<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
    <title>ic_menu_logout</title>
    <desc>Created with Sketch.</desc>
    <g
      id="ic_menu_logout"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M9.10392863,17.7999726 C9.10392863,17.8334223 9.10805322,17.9166961 9.11652414,18.0501443 C9.12503942,18.1834613 9.12707954,18.2937487 9.1229106,18.3812694 C9.11865296,18.4684398 9.1059244,18.566731 9.0848136,18.6749169 C9.06361411,18.7833655 9.02148122,18.8645815 8.95828188,18.9188277 C8.8948608,18.9727674 8.80851055,19 8.69874328,19 L4.64666809,19 C3.64222001,19 2.78324128,18.6479032 2.06986494,17.9434032 C1.356666,17.2395162 1,16.3914543 1,15.3998741 L1,6.59990696 C1,5.60823927 1.356666,4.76039623 2.06986494,4.05624649 C2.78324128,3.35209676 3.64222001,3 4.64666809,3 L8.69861023,3 C8.80833315,3 8.90324302,3.03962293 8.98347291,3.11860608 C9.06361411,3.1979395 9.10375123,3.29150214 9.10375123,3.3998194 C9.10375123,3.43331281 9.10796451,3.51663041 9.11634674,3.64990354 C9.12486202,3.78322046 9.12690214,3.89372683 9.1227332,3.98115996 C9.11847556,4.06868065 9.10574699,4.16649017 9.0846362,4.27480743 C9.0634367,4.38312468 9.02130381,4.4644283 8.95810448,4.51858693 C8.89463904,4.5728769 8.80833315,4.5997592 8.69856588,4.5997592 L4.64666809,4.5997592 C4.08953825,4.5997592 3.61254959,4.79568471 3.21574647,5.1874044 C2.81898771,5.5790803 2.62069702,6.04978314 2.62069702,6.59977562 L2.62069702,15.3999179 C2.62069702,15.9498228 2.81903206,16.4205694 3.21574647,16.8122453 C3.61254959,17.2041839 4.08953825,17.3998468 4.64666809,17.3998468 L8.29342489,17.3998468 L8.43268518,17.3998468 L8.5972252,17.3998468 C8.5972252,17.3998468 8.64570019,17.4040936 8.74282759,17.412456 C8.83999934,17.4206871 8.88847434,17.4332526 8.88847434,17.4498899 C8.88847434,17.466352 8.922225,17.4894252 8.98985937,17.5184966 C9.05749375,17.547568 9.08698677,17.5853083 9.07842714,17.6308419 C9.06982316,17.6766819 9.07856019,17.7333361 9.10392863,17.7999726 Z M20.7567672,10.3593984 C20.9189373,10.5180742 21,10.7061864 21,10.9232524 C21,11.1404062 20.9189373,11.3280796 20.7567672,11.486887 L13.7932253,18.3003382 C13.6311449,18.459014 13.4390694,18.5384615 13.2172232,18.5384615 C12.9952873,18.5384615 12.8032118,18.459014 12.6410417,18.3003382 C12.4788716,18.141794 12.3978537,17.9536818 12.3978537,17.7367474 L12.3978537,14.1295824 L6.66307462,14.1295824 C6.44118354,14.1295824 6.24928744,14.0498716 6.08693796,13.8915029 C5.92476782,13.7329148 5.84375,13.5449781 5.84375,13.3279121 L5.84375,8.51824171 C5.84375,8.30113183 5.92476782,8.11319513 6.08693796,7.95451935 C6.2491081,7.79606292 6.44104903,7.71657148 6.66307462,7.71657148 L12.3978089,7.71657148 L12.3978089,4.10936254 C12.3978089,3.89238426 12.4788267,3.70431596 12.6409969,3.54564017 C12.8032118,3.38718374 12.9952873,3.30769231 13.2171784,3.30769231 C13.4390694,3.30769231 13.6311449,3.38718374 13.7931805,3.54564017 L20.7567672,10.3593984 Z"
        id="Shape"
        fill="#FFF"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
    //Sem uso dos props
    props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/IconLogout.vue